var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroscopeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.0013H1",
    stroke: "#7DCC18",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.66927H3.66667",
    stroke: "#7DCC18",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27529 5.94389C4.75459 5.42321 4.75459 4.57899 5.27529 4.05829L8.05635 1.27724C8.57701 0.756544 9.42128 0.756544 9.94195 1.27724L10.0564 1.39169C10.5771 1.9124 10.5771 2.75663 10.0564 3.27732L7.27528 6.05836C6.75461 6.57902 5.91041 6.57902 5.38969 6.05829L5.27529 5.94389Z",
    stroke: "#7DCC18",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33203 7L5.33203 6",
    stroke: "#7DCC18",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1102 3.33594C11.4567 4.30401 12.3337 5.8842 12.3337 7.66927C12.3337 10.6148 9.94586 13.0026 7.00033 13.0026C4.76209 13.0026 2.84587 11.6238 2.05469 9.66927",
    stroke: "#7DCC18",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscopeGreen);
export default __webpack_public_path__ + "static/media/microscope-green.3462884f6214e377f2757920b5785bcf.svg";
export { ForwardRef as ReactComponent };